import React from "react";

import { useTranslation } from "react-i18next";

import TeamIcon from "@components/icons/TeamIcon";
import { StreakStat } from "@data-types/sport-stats/SportStatsTypes";
import { Team, Tournament } from "@gp/models";
import { mergeStreakStats } from "@utils/statistics/utils-statistics";

export const HeadToHead = (props: {
	title: string;
	data: StreakStat[];
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) => {
	if (!props.data) return null;

	const mergedData = mergeStreakStats(props.data);

	const { t } = useTranslation();

	const homeIcon = (
		<TeamIcon
			showCountryFlag={props.tournament?.showCountryFlag}
			flagCode={props.homeTeam?.countryCode}
			jerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
			opponentFlagCode={props.awayTeam?.countryCode}
			opponentJerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
			className="u-icon u-icon--base u-mar--right--3"
		/>
	);

	const awayIcon = (
		<TeamIcon
			showCountryFlag={props.tournament?.showCountryFlag}
			flagCode={props.awayTeam?.countryCode}
			jerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
			opponentFlagCode={props.homeTeam?.countryCode}
			opponentJerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
			className="u-icon u-icon--base u-mar--left--3"
		/>
	);

	return (
		<div className="card card--raised card--stats" data-at="at-HeadToHead">
			<div className="card__header card--stats__header">
				<div className="card__title card__title--base card--stats__heading">
					{props.title}
				</div>
			</div>

			<div className="card--stats__body">
				<div className="card--stats__row">
					<div className="card--stats__col card--stats__col--left">
						{homeIcon}
						<div className="card--stats__value">
							{t("EVENT.OFFER.COMPETITOR_HOME")}
						</div>
					</div>
					<div className="card--stats__col card--stats__col--right">
						<div className="card--stats__value">
							{t("EVENT.OFFER.COMPETITOR_AWAY")}
						</div>
						{awayIcon}
					</div>
				</div>

				{mergedData.map((item, index) => (
					<div
						key={`${index}`}
						className="card--stats__row"
						data-at="at-HeadToHead__row"
					>
						<div className="card--stats__col card--stats__col--left">
							<div className="card--stats__value">
								{item.team === "both"
									? item.value
									: (item.homeValue ?? "-")}
							</div>
						</div>
						<div className="card--stats__col card--stats__col--middle">
							<div className="card--stats__label">
								{t(
									`EVENT.STATISTICS.STREAK_STATS.${item.abrv}`,
									{ margin: item.margin }
								)}
							</div>
						</div>
						<div className="card--stats__col card--stats__col--right">
							<div className="card--stats__value">
								{item.team === "both"
									? item.value
									: (item.awayValue ?? "-")}
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
